import axios from "axios";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { FaRegCheckCircle as Check } from "react-icons/fa";
import { FiPlus as Plus } from "react-icons/fi";
import { HiDotsVertical as Menu } from "react-icons/hi";
import { NotificationManager } from "react-notifications";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import call from "../../assets/svgs/call 2.svg";
import text from "../../assets/svgs/chat.svg";
import Complete from "../../assets/svgs/Complete.svg";
import high from "../../assets/svgs/high.svg";
import low from "../../assets/svgs/low.svg";
import medium from "../../assets/svgs/medium.svg";
import addTaskIcon from "../../assets/svgs/add-task.svg";
import none from "../../assets/svgs/None.svg";
import sortAsce from "../../assets/svgs/sort-ascending.svg";
import sortDesc from "../../assets/svgs/sort-descending.svg";
import swap from "../../assets/svgs/swap-vertical.svg";

import AddNoteModal from "../../components/DetailTabsData/Modals/AddNoteModal";
import ResheduleTaskModal from "../../components/DetailTabsData/Modals/ResheduleTaskModal";
import useAuth from "../../hooks/useAuth";
import AddTaskModal from "../../pages/Tasks/modals/AddTaskModal";
import EditTaskModal from "../../pages/Tasks/modals/EditTaskModal";
import TaskDetailsModal from "../../pages/Tasks/TaskDetailsModal";
import { BASE_URL } from "../../utils/Element";
import { initialTaskFilterData } from "../../utils/initialData";
import ArchiveConfirmationModal from "../ConfirmationModals/ArchiveConfirmationModal";
import DeleteConfirmationModal from "../ConfirmationModals/DeleteConfirmationModal";
import UnarchiveConfirmationModal from "../ConfirmationModals/UnarchieveConfirmationModal";
import Loader from "../Loader";
import ContactPagination from "../Pagination/ContactPagination";
import CompleteTaskModal from "./Modals/CompleteTaskModal";

const TaskTab = ({ from, data }) => {
  const [config] = useAuth();
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const dropdownRefs = useRef({});

  const [isOpen, setIsOpen] = useState(null);
  const [date, setDate] = useState();
  const [taskData, setTaskData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(10);
  const [selectedTask, setSelectedTask] = useState(null);

  const [showtaskModal, setShowtaskModal] = useState(false);
  const [sortBy, setSortBy] = useState("id");
  const [sortDirection, setSortDirection] = useState("asc");
  const [disableDelete, setDisableDelete] = useState(false);

  const [showNotesModal, setShowNotesModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showArchiveModal, setShowArchiveModal] = useState(false);
  const [showEditTaskModal, setShowEditTaskModal] = useState(false);
  const [showUnarchiveModal, setShowUnarchiveModal] = useState(false);
  const [showCompleteTaskModal, setShowCompleteTaskModal] = useState(false);
  const [showResheduleTaskModal, setShowResheduleTaskModal] = useState(false);

  const isSidebarCollapsed = useSelector((state) => state.isSidebarCollapsed);

  const [paginationData, setPaginationData] = useState({
    totalItems: 0,
    from: 0,
    to: 0,
    totalPages: 0,
  });

  const [filterData, setFilterData] = useState(() => {
    const localFilterData = localStorage.getItem("filterData");
    return localFilterData ? JSON.parse(localFilterData) : initialTaskFilterData;
  });

  const [tabSearch, setTabSearch] = useState("");

  // Dropdown Handlers
  const handleMenuClick = (idx) => {
    setIsOpen((prev) => (prev === idx ? null : idx));
  };

  const handleDropdownOptionClick = () => {
    setIsOpen(null);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen !== null) {
        const openDropdown = dropdownRefs.current[isOpen];
        if (openDropdown && !openDropdown.contains(event.target)) {
          setIsOpen(null);
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  const buildQueryParams = (filters) => {
    let params = `page=${currentPage}&per_page=${itemPerPage}`;

    const { selectedPriorities, selectedTaskTypes, selectedLinkedOptions, isRepeatingTask, selectedDueDate } = filters;

    if (Array.isArray(selectedPriorities) && selectedPriorities.length > 0) {
      params += `&priority=${selectedPriorities.join(",")}`;
    }
    if (Array.isArray(selectedTaskTypes) && selectedTaskTypes.length > 0) {
      params += `&task_type=${encodeURIComponent(selectedTaskTypes.join(","))}`;
    }
    if (Array.isArray(selectedLinkedOptions) && selectedLinkedOptions.length > 0) {
      params += `&linked_to=${encodeURIComponent(selectedLinkedOptions.join(","))}`;
    }
    if (isRepeatingTask !== "no") {
      params += `&repeating_tasks=${isRepeatingTask}`;
    }
    if (selectedDueDate) {
      params += `&due_date=${selectedDueDate}`;
    }
    if (sortBy !== "id") {
      params += `&sort_column=${sortBy}&sort_direction=${sortDirection}`;
    }
    if (tabSearch) {
      params += `&search=${tabSearch}`;
    }

    return params;
  };

  const fetchTaskdata = (filters) => {
    const queryParams = buildQueryParams(filters);
    if (!from || !id) {
      console.error("Error: 'from' or 'id' is undefined");
      return;
    }

    const type = from === "contact" ? `contact_id=${id}` : `company_id=${id}`;

    axios
      .get(`${BASE_URL}/task-list?${type}&status=0&${queryParams}`, config)
      .then((res) => {
        const value = res?.data?.tasks || {};
        setTaskData(value?.data || []);
        setPaginationData({
          totalItems: value?.total ?? 0,
          from: value?.from ?? 0,
          to: value?.to ?? 0,
          totalPages: value?.last_page ?? 0,
        });
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
        setTaskData([]);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchTaskdata(filterData);
  }, [currentPage, itemPerPage, sortBy, sortDirection, tabSearch]);

  const onSuccess = () => {
    setLoading(true);
    fetchTaskdata(filterData);
  };

  const handleResheduleTask = () => {
    axios
      .post(`${BASE_URL}/perform-Action?action=reschedule&task_id=${selectedTask?.id}`, { due_date: date }, config)
      .then((res) => {
        onSuccess();
        setShowResheduleTaskModal(false);
        if (res?.data?.message) NotificationManager.success(res?.data?.message);
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };

  const handleArchieve = () => {
    axios
      .post(`${BASE_URL}/perform-Action?action=archive&task_id=${selectedTask?.id}`, {}, config)
      .then((res) => {
        onSuccess();
        setShowArchiveModal(false);
        if (res?.data?.message) NotificationManager.success(res?.data?.message);
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };

  const handleUnarchieve = () => {
    axios
      .post(`${BASE_URL}/perform-Action?action=unarchive&task_id=${selectedTask?.id}`, {}, config)
      .then((res) => {
        onSuccess();
        setShowUnarchiveModal(false);
        if (res?.data?.message) NotificationManager.success(res?.data?.message);
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };

  const handleDelete = () => {
    setDisableDelete(true);
    axios
      .post(`${BASE_URL}/perform-Action?action=delete&task_id=${selectedTask?.id}`, {}, config)
      .then((res) => {
        onSuccess();
        setShowDeleteModal(false);
        if (res?.data?.message) NotificationManager.success(res?.data?.message);
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      })
      .finally(() => setDisableDelete(false));
  };

  const getDueDateInfo = (dueDate) => {
    const now = moment().tz("America/New_York").startOf("day");
    const due = moment(dueDate).tz("America/New_York").startOf("day");
    const daysDiff = due.diff(now, "days");

    if (daysDiff < 0) return { className: "red-D red-bg-L", label: "Past Due" };
    if (daysDiff === 0) return { className: "orange-D orange-bg-L", label: "Due Today" };
    if (daysDiff <= 7) return { className: "green-D green-bg", label: "Due Next 7 Days" };
    return { className: "puple_D puple-bg-L dark-M", label: "Due Later" };
  };

  return (
    <div>
      <div className="flex justify-between items-start head-5 green-H">
        <div className="search-box contacts">
          <input
            type="text"
            className="body-S"
            placeholder="Search Here..."
            value={tabSearch}
            onChange={(e) => setTabSearch(e.target.value)}
            style={{ border: "1px solid #D8D8D8", marginTop: "0px" }}
          />
        </div>

        <p className="head-5 green-H flex items-center gap-1" role="button" onClick={() => setShowModal(true)}>
          <Plus /> Add Task
        </p>
      </div>

      <div className="light-bg-L pb-3 table-container">
        <div className={`${isSidebarCollapsed ? "tab-collapsed-width" : "tab-width"} table-info light-bg-L`}>
          {loading ? (
            <Loader />
          ) : taskData.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-12 mt-6 bg-white rounded-xl">
              <img src={addTaskIcon} alt="No Tasks" className="w-16 h-16 mb-4 opacity-60" />
              <p className="head-4 dark-H mb-2">No Tasks Available</p>
              <p className="body-N dark-M mb-6">There are no tasks matching your search.</p>
            </div>
          ) : (
            <table className="contact-table light-bg-L">
              <thead>
                <tr className="uppercase body-N dark-M">
                  <th className="green-H">
                    <div className="table-header">
                      Task
                      <img
                        role="button"
                        src={sortBy !== "task_name" ? swap : sortDirection === "desc" ? sortDesc : sortAsce}
                        onClick={() => {
                          setSortBy("task_name");
                          setSortDirection(sortDirection === "desc" ? "asc" : "desc");
                        }}
                        alt="icon"
                      />
                    </div>
                  </th>
                  <th>
                    <div className="table-header">
                      Assigned To
                      <img
                        role="button"
                        src={sortBy !== "user_id" ? swap : sortDirection === "desc" ? sortDesc : sortAsce}
                        alt="icon"
                        onClick={() => {
                          setSortBy("user_id");
                          setSortDirection(sortDirection === "desc" ? "asc" : "desc");
                        }}
                      />
                    </div>
                  </th>
                  <th>
                    <div className="table-header">
                      Priority
                      <img
                        role="button"
                        src={sortBy !== "priority" ? swap : sortDirection === "desc" ? sortDesc : sortAsce}
                        onClick={() => {
                          setSortBy("priority");
                          setSortDirection(sortDirection === "desc" ? "asc" : "desc");
                        }}
                        alt="icon"
                      />
                    </div>
                  </th>
                  <th>
                    <div className="table-header">
                      Due Date
                      <img
                        role="button"
                        src={sortBy !== "due_date" ? swap : sortDirection === "desc" ? sortDesc : sortAsce}
                        alt="icon"
                        onClick={() => {
                          setSortBy("due_date");
                          setSortDirection(sortDirection === "desc" ? "asc" : "desc");
                        }}
                      />
                    </div>
                  </th>
                  <th>
                    <div className="table-header">
                      Created By
                      <img
                        role="button"
                        src={sortBy !== "created_by" ? swap : sortDirection === "desc" ? sortDesc : sortAsce}
                        alt="icon"
                        onClick={() => {
                          setSortBy("created_by");
                          setSortDirection(sortDirection === "desc" ? "asc" : "desc");
                        }}
                      />
                    </div>
                  </th>
                  <th>
                    <div className="table-header">More</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {taskData.map((el, idx) => (
                  <tr key={el.id} className="body-N dark-H">
                    <td
                      className="head-4 flex items-center gap-2 capitalize"
                      role="button"
                      onClick={() => {
                        setShowtaskModal(true);
                        setSelectedTask(el);
                      }}
                    >
                      {el.task_name}
                      {el.task_name === "Call" ? <img src={call} alt="Call" /> : el.task_name === "Text" ? <img src={text} alt="Text" /> : null}
                    </td>

                    <td className="capitalize">
                      {`${el?.user?.first_name || ""} ${el?.user?.last_name || ""}`}
                    </td>

                    <td className="dark-M body-S">
                      <div className="priority flex items-center gap-2 capitalize">
                        {el.priority === "medium" ? <img src={medium} alt="" /> :
                         el.priority === "low" ? <img src={low} alt="" /> :
                         el.priority === "high" ? <img src={high} alt="" /> : <img src={none} alt="" />}
                        {el.priority || "None"}
                      </div>
                    </td>

                    <td>
                      {moment(el.due_date).tz("America/New_York").format("MM/DD/YYYY")}
                      <span className={`due-date body-S ml-2 ${getDueDateInfo(moment(el.due_date)).className}`}>
                        {getDueDateInfo(moment(el.due_date)).label}
                      </span>
                    </td>

                    <td className="capitalize">
                      {el?.touch_plan?.name
                        ? el.touch_plan.name
                        : `${el?.created_by?.first_name || ""} ${el?.created_by?.last_name || ""}`}
                    </td>

                    {/* ==================== MORE COLUMN - FIXED ==================== */}
                    <td className="flex gap-3 items-center">
                      {el.status == 1 && <img src={Complete} alt="Completed" />}

                      {el.status == 2 ? (
                        <div className="custom-dropdown" ref={(node) => (dropdownRefs.current[idx] = node)}>
                          <div
                            role="button"
                            className="pt-0.5 cursor-pointer"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleMenuClick(idx);
                            }}
                          >
                            <Menu size={20} />
                          </div>
                          {isOpen === idx && (
                            <ul className="dropdown-list-container dropdown-end light-bg-L dark-M body-N p-2 shadow rounded-box w-52" onClick={(e) => e.stopPropagation()}>
                              <li role="button" onClick={() => { setShowUnarchiveModal(true); setSelectedTask(el); handleDropdownOptionClick(); }}>Unarchive</li>
                              <li role="button" className="mt-2 red-D" onClick={() => { setShowDeleteModal(true); setSelectedTask(el); handleDropdownOptionClick(); }}>Delete</li>
                            </ul>
                          )}
                        </div>
                      ) : (
                        <div className="flex gap-2">
                          <Check
                            className="dark-M cursor-pointer"
                            size={20}
                            role="button"
                            onClick={() => {
                              setShowCompleteTaskModal(true);
                              setSelectedTask(el);
                            }}
                          />
                          <div className="custom-dropdown" ref={(node) => (dropdownRefs.current[idx] = node)}>
                            <div
                              role="button"
                              className="pt-0.5 cursor-pointer"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleMenuClick(idx);
                              }}
                            >
                              <Menu size={20} />
                            </div>
                            {isOpen === idx && (
                              <ul className="dropdown-list-container dropdown-end light-bg-L dark-M body-N p-2 shadow rounded-box w-52" onClick={(e) => e.stopPropagation()}>
                                <li role="button" onClick={() => { setShowEditTaskModal(true); setSelectedTask(el); handleDropdownOptionClick(); }}>Edit</li>
                                <li role="button" className="mt-2" onClick={() => { setShowResheduleTaskModal(true); setSelectedTask(el); handleDropdownOptionClick(); }}>Reschedule</li>
                                <li role="button" className="mt-2 red-D" onClick={() => { setShowArchiveModal(true); setSelectedTask(el); handleDropdownOptionClick(); }}>Archive</li>
                              </ul>
                            )}
                          </div>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {taskData.length !== 0 && (
          <ContactPagination
            paginationData={paginationData}
            handleNext={() => currentPage !== paginationData.totalPages && setCurrentPage(currentPage + 1)}
            handlePrev={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
            onSuccess={onSuccess}
            itemPerPage={itemPerPage}
            handleItemPerPageSelect={(value) => {
              setItemPerPage(value);
              setCurrentPage(1);
            }}
          />
        )}
      </div>

      {/* Modals */}
      <AddTaskModal showModal={showModal} onClose={() => setShowModal(false)} from={from} data={data} onSuccess={onSuccess} />
      <TaskDetailsModal showModal={showtaskModal} onClose={() => setShowtaskModal(false)} id={selectedTask?.id} onCallApiAgain={onSuccess} />
      <CompleteTaskModal showModal={showCompleteTaskModal} onClose={() => setShowCompleteTaskModal(false)} onTaskCompleted={onSuccess} taskData={selectedTask} />
      <ArchiveConfirmationModal showModal={showArchiveModal} onClose={() => setShowArchiveModal(false)} handleAction={handleArchieve} />
      <UnarchiveConfirmationModal showModal={showUnarchiveModal} onClose={() => setShowUnarchiveModal(false)} handleAction={handleUnarchieve} />
      <DeleteConfirmationModal showModal={showDeleteModal} disable={disableDelete} onClose={() => setShowDeleteModal(false)} handleDelete={handleDelete} />
      <EditTaskModal showModal={showEditTaskModal} onClose={() => setShowEditTaskModal(false)} taskInitialData={selectedTask} onTaskEdited={onSuccess} />
      <ResheduleTaskModal
        showModal={showResheduleTaskModal}
        onClose={() => setShowResheduleTaskModal(false)}
        taskData={selectedTask}
        ontaskReshedule={onSuccess}
        handleResheduleTask={handleResheduleTask}
        onDateChange={setDate}
      />
      <AddNoteModal showModal={showNotesModal} onClose={() => setShowNotesModal(false)} taskData={selectedTask} onnotesAdded={onSuccess} />
    </div>
  );
};

export default TaskTab;